export const GET_DATASPACES = 'GET_DATASPACES';
export const IS_LOADING = ' IS_LOADING';
export const GET_SELECTED_DATASPACE = 'GET_SELECTED_DATASPACE';
export const GET_MY_DATASPACES = 'GET_MY_DATASPACES';
export const GET_MY_SELECTED_DATASPACE = 'GET_MY_SELECTED_DATASPACE';
export const GET_DATASPACE_CONNECTOR = 'GET_DATASPACE_CONNECTOR';
